<template>
  <div class="login-container">
    <!-- <div class="beijing">
      <div class="bottom"></div>
      <div class="earth"></div>
      <div class="elliptical"></div>
    </div> -->
    <div class="login-form">
      <div class="title">仪器考试在线系统</div>
      <div class="title1">welcome to login</div>
      <!-- tab页 -->
       <el-tabs v-model="activeName">
        <el-tab-pane label="学员登录" name="first" >
          <el-button type="primary" @click="login" class="buttonClass">练习</el-button>
        </el-tab-pane>
        <el-tab-pane label="考试登录" name="second">
          <div class="loginClass">
        <div class="loginTu"></div>
        <el-input v-model="formLabelAlign.nickname" class="input" placeholder="请输入身份证"></el-input>
      </div>
      <!-- <div class="passClass">
        <div class="passTu"></div>
        <el-input v-model="formLabelAlign.password" class="input" placeholder="请输入密码" show-password></el-input>
      </div> -->
      
      <el-button type="primary" @click="loginExam" class="buttonClass">考试登录</el-button>
        </el-tab-pane>
      </el-tabs>

      <!-- <input type="file"
             @change="handleFileUpload"> -->

      <!-- <button @click="exportXls">导出 Excel</button> -->
      <!-- <el-form
        label-position="right"
        label-width="80px"
        :model="formLabelAlign"
      >
        <el-form-item label="账号">
          <el-input v-model="formLabelAlign.nickname"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="formLabelAlign.password"></el-input>
        </el-form-item>
        <el-form-item class="button-group">
          <el-button type="primary" @click="login">登入</el-button>
          <el-button type="primary">重置</el-button>
        </el-form-item>
      </el-form> -->
    </div>
    <!-- 确认进入弹窗 -->
    <el-dialog
      title="确认进入考试系统吗？"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="30%"
    >
      <!-- <div v-for="item in examList" :key="item.id">
        <div class="exam-item">
          <div>{{ item.examName }}</div> 
          <div>{{ item.time }}</div>
          <el-button type="primary" @click="enterExam(item)">进入考试</el-button>
        </div>
      </div> -->
      <div>姓名：{{ student.name }}</div>
      <div>准考证号：{{ student.admissionTicket }}</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmEnter">确认进入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Post } from '../utils/request'
export default {
  name: 'loginIndex',
  data() {
    return {
      formLabelAlign: {
        nickname: '',
        password: '',
        
      },
      activeName: "first",
      dialogVisible: false,
      student: {
        admissionTicket: '',
        name: '',
        teacherId: 0,
        id: 0
      },
      examList: [
        {time:'2023-12-12', examName: '考试1'},
      ]
    }
  },
  created() {
  },
  methods: {
    // handleClick(tab) {
    //   console.log(tab)
    //   this.activeName = tab.index
    // },
    login() {
       window.location.href = window.$stuUrl
      // let obj = {}
      // obj.admissionTicket = this.formLabelAlign.nickname
      // obj.password = this.formLabelAlign.password
      // let msg = {}
      // msg.data = obj
      // msg.vm = this
      // msg.fn = this.resLogin
      // Post('student/login', msg)
    },
    resLogin(res) {
      if (res.err_code !== 200) {
        this.$message.error(res.err_msg)
        return
      }
      let data = res.data
      window.location.href = `${window.$stuUrl}?admissionTicket=${data.admissionTicket}&name=${data.name}&teacherId=${data.teacherId}`
    },
    loginExam() {
      let obj = {}
      obj.admissionTicket = this.formLabelAlign.nickname
      obj.password = this.formLabelAlign.password
      let msg = {}
      msg.data = obj
      msg.vm = this
      msg.fn = this.resLoginExam
      Post('student/login', msg)
    },
    resLoginExam(res) {
      if (res.err_code !== 200) {
        this.$message.error(res.err_msg)
        return
      }
      let data = res.data
      this.dialogVisible = true
      this.student.admissionTicket = data.admissionTicket
      this.student.name = data.name
      this.student.teacherId = data.teacherId
      this.student.id = data.id
      // window.location.href = `${window.$ExamUrl}?admissionTicket=${data.admissionTicket}&name=${data.name}&teacherId=${data.teacherId}&id=${data.id}`
    },
    confirmEnter() {
      window.location.href = `${window.$ExamUrl}?admissionTicket=${this.student.admissionTicket}&name=${this.student.name}&teacherId=${this.student.teacherId}&id=${this.student.id}`
      this.dialogVisible = false
    },
    enterExam(exam) {
      console.log(exam)
    },
  }
}
</script>

<style scoped>
.login-container {
  width: 100vw;
  /* margin: auto; */
  height: 100vh;
  /* display: flex; */
  /* align-items: center; */
  /* justify-content: center; */
  background: url(../assets/login/background.png) no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  position: relative;
}

.bottom {
  width: 46vw;
  height: 43vh;
  position: absolute;
  left: 88px;
  top: 516px;
  background-image: url(../assets/login/bottom.png);
  background-size: cover;
}
.earth {
  width: 508px;
  height: 509px;
  position: absolute;
  left: 284px;
  top: 171px;
  background-image: url(../assets/login/earth.png);
  background-size: cover;
}
.elliptical {
  width: 631px;
  height: 535px;
  position: absolute;
  left: 213px;
  top: 161px;
  background-image: url(../assets/login/elliptical.png);
  background-size: cover;
}
.login-form {
  width: 26vw;
  /* float: right; */
  position: absolute;
  right: 10vw;
  top: 20vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* margin-right: 192px;
  margin-top: 273px; */
}
.title {
  font-size: 3vw;
  font-family: PangMenZhengDao;
  color: #0079c4;
  text-align: center;
  /* font-weight: 400;  */
}
.title1 {
  font-size: 1.5vw;
  font-family: SourceHanSansCN-Regular;
  text-align: center;
}
.passClass {
  height: 7vh;
  width: 26vw;
  margin-top: 4vh;
  /* border: 1px solid #0079C4; */
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: white;
}
.loginClass {
  height: 7vh;
  width: 26vw;
  margin-top: 4vh;
  /* border: 1px solid #0079C4; */
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: white;
}
.loginTu {
  width: 1.7vw;
  height: 4vh;
  background: url(../assets/login/login.png) no-repeat;
  background-size: 100% 100%;
  /* background-size: cover; */
  /* margin-left: 1vw; */
  /* margin-top: 16px; */
}
.passTu {
  width: 1.7vw;
  height: 4vh;
  background: url(../assets/login/password.png) no-repeat;
  background-size: 100% 100%;
  /* background-size: cover; */
  /* margin-left: 1vw; */
  /* margin-top: 17px; */
}
.input {
  width: 20vw;
  height: 32px;
  /* margin-left: 2vw; */
  margin-bottom: 5px;
}
.input.no-border .el-input__inner {
  border: none; /* 去掉输入框边框 */
  outline: none; /* 去掉输入框聚焦时的轮廓线 */
  box-shadow: none; /* 去掉输入框可能存在的阴影 */
}
.buttonClass {
  width: 24vw;
  height: 7vh;
  margin-top: 43px;
  font-size: 1vw;
  border-radius: 10px;
}
.dialog-footer {
  display: flex;
  justify-content: flex-end;
}
/deep/.el-tabs__item{
  font-size: 30px;
}
.exam-item{
  height: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>